import { supabase } from "./supabaseClient";

const seenErrors = new Map();
const WINDOW_MS = 60_000;

const cleanText = (value, max = 900) => String(value || "")
  .replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/g, "[email]")
  .replace(/(access_token|refresh_token|apikey|authorization)[=:][^\s&]+/gi, "$1=[redacted]")
  .slice(0, max);

export async function reportClientError(error, context = {}) {
  try {
    const message = cleanText(error?.message || error || "Unknown client error", 500);
    const fingerprint = `${message}:${cleanText(context.componentStack || error?.stack, 180)}`;
    const lastSeen = seenErrors.get(fingerprint) || 0;
    if (Date.now() - lastSeen < WINDOW_MS) return;
    seenErrors.set(fingerprint, Date.now());

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase.from("incidents").insert({
      user_id: user.id,
      issue: [
        "[AUTO] Client error",
        message,
        `หน้า: ${cleanText(window.location.pathname, 120)}`,
        `เบราว์เซอร์: ${cleanText(navigator.userAgent, 240)}`,
        context.componentStack ? `Component: ${cleanText(context.componentStack, 500)}` : "",
      ].filter(Boolean).join("\n"),
      status: "pending",
      created_at: new Date().toISOString(),
    });
  } catch (monitoringError) {
    console.warn("Client error monitoring unavailable", monitoringError?.message || monitoringError);
  }
}

export function installGlobalErrorMonitoring() {
  window.addEventListener("error", (event) => {
    if (event?.message?.includes("ResizeObserver loop")) return;
    reportClientError(event.error || event.message, { source: "window.error" });
  });
  window.addEventListener("unhandledrejection", (event) => {
    reportClientError(event.reason, { source: "unhandledrejection" });
  });
}
